import React, { useEffect, useRef, useState } from "react";
import "../Style.css";
import "../Responsive.css";
import "../bootstrap.min.css";
import {
  TextField,
  Container,
  Grid,
  Stack,
  FormControl,
  Typography,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Box,
  Card,
  FormGroup,
  Button,
  Modal,
  InputLabel,
  IconButton,
  Tooltip,
  DialogContent,
  DialogActions,
  DialogTitle,
  styled,
  Dialog,
} from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";
import { connectToStore } from "../data/store";
import {
  CampaignContentType,
  CampaignSegmentTypes,
  CampaignTypes,
  ClassificationTypes,
  MaxDateLimit,
  MaxFileSizeLimit,
  OfferTypes,
  SideBarMenuNames,
} from "../core/Constants";
import SideBarMenuItems from "./SideBarMenuItems";
import Utils from "../core/Utils";
import { getCountry, getEnterpriseId } from "../data/localSettingsActions";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";

// Images
import Email_Img from "../images/email.png";
import PushNotification_Img from "../images/pushNotification.png";
import SMS_Img from "../images/sms.png";
import Insta_Img from "../images/insta.png";
import Preview_Img from "../images/preview-img.png";

// Datepicker
import "../DateRangePickerWithYear.css";
import "react-calendar/dist/Calendar.css";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import CountryHelper from "../core/CountryHelper";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { Label } from "@mui/icons-material";

import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import Loader from "./common/Loader";
import MessagePopup from "./common/MessagePopUp";
import { loadProductsFromServer, postAsync } from "../core/serviceClient";
import NumericTextField from "./common/controls/NumericTextField";
import { CampaignsPage } from "../core/PageConstants";
import DecimalEntryField from "./common/controls/DecimalEntryField";
import ProductSelectionModal from "./common/ProductSelectionModal";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ClearIcon from "@mui/icons-material/Clear";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const isEmptyOrZero = (v) => {
  if (v === null || v === undefined) return true;
  const s = String(v).trim();
  if (s === "") return true;
  if (/^0+(\.0+)?$/.test(s)) return true;
  return false;
};

const AddNewCampaign = () => {
  document.title = "New Campaign";
  const navigate = useNavigate();
  const location = useLocation();
  const colors = ["#fcfcfc", "#9370db", "#87ceeb", "#2e8b57", "#ff6347"];
  const colorname = ["White", "MediumPurple", "SkyBlue", "SeaGreen", "Tomato"];
  const channelEnumTypes = {
    Email: "Email",
    Push: "Push",
    SMS: "SMS",
  };

  const [localSettings, setLocalSettings] = useState(connectToStore());
  const [selectedDate, setSelectedDate] = useState([
    Utils.GetTodayStartDate(),
    Utils.NextEndDate(7),
  ]);

  const [campTypeValue, setCampTypeValue] = React.useState(
    CampaignTypes.SpendXGetY
  );
  const [campGetTypeValue, setCampGetTypeValue] = React.useState(
    OfferTypes.PercentDiscount
  );
  const [campContentTypeValue, setCampContentTypeValue] = React.useState(
    CampaignContentType.Coupon
  );
  const [anonymous, setAnonymous] = useState(false);
  const [campaignName, setCampaignName] = useState("");
  const [offerImage, setOfferImage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [selectedColor, setSelectedColor] = useState("White");
  const [offerImageName, setOfferImageName] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [allCategories, setAllCatogories] = useState([]);
  const [allDepartments, setAllDepartments] = useState([]);
  const [filteredAllProducts, setFilteredAllProducts] = useState([]);
  const [filteredAllCategories, setFilteredAllCategories] = useState([]);
  const [filteredAllDepartments, setFilteredAllDepartments] = useState([]);
  const [XValue, setXValue] = useState(1);
  const [YValue, setYValue] = useState(1);
  const [YQuantity, setYQuantity] = useState(1);
  const [tiersList, setTiersList] = useState([]);
  const [locationsList, setLocationsList] = useState([]);
  const [buyRadioSelect, setBuyRadioSelect] = useState(
    ClassificationTypes.Class
  );
  const [discountRadioSelect, setDiscountRadioSelect] = useState(
    ClassificationTypes.Class
  );
  const [buyProducts, setBuyProducts] = useState({});
  const [discountProducts, setDiscountProducts] = useState({});
  const [freeProducts, setFreeProducts] = useState({});
  const [channels, setChannels] = useState([channelEnumTypes.Push]);
  const [creativeContent, setCreativeContent] = useState("");
  const [offerType, setOfferType] = useState("");
  const [productsX, setProductsX] = useState([]);
  const [productsY, setProductsY] = useState([]);
  const [productXAny, setProductXAny] = useState("All");
  const [segments, setSegments] = useState([]);
  const [creativeLine1, setCreativeLine1] = useState("");
  const [creativeLine2, setCreativeLine2] = useState("");
  const [creativeLine3, setCreativeLine3] = useState("");
  const [creativeLine4, setCreativeLine4] = useState("");
  const [selectedTiers, setSelectedTiers] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [customerCount, setCustomerCount] = useState(0);
  const [countryInfo, setCountryInfo] = useState({});
  const [isCustomMsg, setIsCustomMsg] = useState(false);
  const [isSmsInclude, setIsSmsInclude] = useState(false);
  const [openBuyProductsModal, setOpenBuyProductsModal] = useState(false);
  const [openDiscountProdutsModal, setOpenDiscountProdutsModal] =
    useState(false);
  const [openFreeProductsModal, setOpenFreeProductsModal] = useState(false);
  const [isNavigateToAllCampaigns, setIsNavigateToAllCampaigns] =
    useState(false);
  const [campaignId, setCampaignId] = useState("");
  const [campaignBtnStatus, setCampaignBtnStatus] = useState("Save");
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [isReadOnlyCampaign, setIsReadOnlyCampaign] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [openSelectedProducts, setOpenSelectedProducts] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchLocationValue,setSearchLocationValue] = useState("");
  const [filteredLocationsList, setFilteredLocationsList] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const fileInputRef = useRef();

  useEffect(() => {
    let localSetting = connectToStore();
    setLocalSettings(localSetting);
    if (localSetting.authenticated) {
      setCountryInfo(getCountry());
      getAllProductsData();
    }
    if (!Utils.IsNullOrEmptyArray(localSetting?.business?.tiers)) {
      let tiersList = localSetting?.business?.tiers;
      if (!Utils.IsNullOrEmptyArray(tiersList)) {
        tiersList.forEach((tier) => {
          tier.locationTierCount = 0;
          tier.isChecked = false;
        });
      }
      let locationsList = localSetting?.business?.localities;
      if (!Utils.IsNullOrEmptyArray(locationsList)) {
        locationsList.forEach((location) => {
          location.isChecked = false;
        });
      }
      let newCutomerCount = 0;
      if (!Utils.IsNullOrEmptyObject(location?.state?.campaign)) {
        let newSegments = location?.state?.campaign?.segments;
        if (!Utils.IsNullOrEmptyArray(newSegments)) {
          newSegments.forEach((segment) => {
            if (segment.type === "Tier") {
              let selectedTier = tiersList.find(
                (tier) => tier.level === segment.value
              );
              let selectedTierIndex = tiersList.findIndex(
                (tier) => tier.level === segment.value
              );
              if (selectedTier) {
                tiersList[selectedTierIndex].isChecked = true;
              }
            } else if (segment.type === "Location") {
              let selectedLocation = locationsList.find(
                (location) => location.name === segment.value
              );
              let selectedLocationIndex = locationsList.findIndex(
                (tier) => tier.name === segment.value
              );

              if (selectedLocation) {
                const locationTier = selectedLocation.tiers[0];
                let tiersListSelectedIndex = tiersList.findIndex(
                  (tier) => tier.level === locationTier.level
                );
                if (tiersListSelectedIndex >= 0) {
                  tiersList[tiersListSelectedIndex].locationTierCount =
                    (tiersList[tiersListSelectedIndex].locationTierCount || 0) +
                    (locationTier.customerCount || 0);
                }
                newCutomerCount += locationTier?.customerCount;

                locationsList[selectedLocationIndex].isChecked = true;
              }
            }
          });
        }
      } else {

      }
      setTiersList(tiersList);
      // sorting locationLIst based on customerCount
      let newLocationList = locationsList.sort((a, b) => {
        const aCount = a.tiers?.[0]?.customerCount || 0;
        const bCount = b.tiers?.[0]?.customerCount || 0;
        return bCount - aCount;
      });
      setLocationsList(newLocationList);
      setFilteredLocationsList(newLocationList);
    }
    if (!Utils.IsNullOrEmptyObject(location?.state?.campaign)) {
      IntializeCampaign();
    }
  }, []);

  useEffect(() => {
    if(isReadOnlyCampaign || isLoading) {
      setIsProcessing(true);
    } else {
      setIsProcessing(false);
    }
  },[isReadOnlyCampaign,isLoading])

  useEffect(() => {
  const total = tiersList.reduce((sum, tier) => {
    // Rule 1: If locationTierCount > 0 → always add
    if (tier.locationTierCount > 0) {
      return sum + tier.locationTierCount;
    }

    // Rule 2: Otherwise add only if the tier is selected
    if (tier.isChecked) {
      return sum + (tier.customerCount || 0);
    }

    return sum;
  }, 0);
  setCustomerCount(total);
}, [tiersList]);

  useEffect(() => {
    getCreativeLineValues();
  }, [campTypeValue, campGetTypeValue, XValue, YValue, isCustomMsg, productsX, productsY]);

  useEffect(() => {
    let todayDate = moment().startOf("day");
    let startDate = selectedDate[0];
    if (startDate) {
      let dateDiff = selectedDate[0].diff(todayDate, "days");
      if (dateDiff >= 0) {
        setCreativeLine2(`in the next 7 days and`);
      }
    }
  }, [selectedDate]);

  const IntializeCampaign = () => {
    let selectedCampaign = location?.state?.campaign;
    let allChannels = selectedCampaign?.channels.split(",") || [];
    let isSmsChecked = allChannels.includes(channelEnumTypes.SMS);
    if (location?.state?.isEdit) {
      setCampaignBtnStatus("Update");
    } else if (location?.state?.isDelete) {
      setCampaignBtnStatus("Delete");
    } else if (location?.state?.isApprove) {
      setCampaignBtnStatus("Approve");
    } else if (location?.state?.isEndCampaign) {
      setCampaignBtnStatus("End");
    } else if (location?.state?.isReadOnlyCampaign) {
      setIsReadOnlyCampaign(true);
    }
    if (selectedCampaign?.creativeIsHtml && !Utils.IsNullOrEmpty(selectedCampaign?.creative)) {
      // setCreativeContent(selectedCampaign?.creative)
      fetchHtml(selectedCampaign?.creative)
    }
    setIsSmsInclude(isSmsChecked);
    setCampaignName(selectedCampaign?.name || "");
    setCampTypeValue(selectedCampaign?.type);
    setChannels(selectedCampaign?.channels.split(","));
    setSelectedColor(selectedCampaign?.creativeBGColor);
    const start = moment(selectedCampaign?.start).startOf("day");
    const end = moment(selectedCampaign?.end).startOf("day");
    const today = moment().startOf("day");
    let finalStart = start;
    let finalEnd = end;

    if (start.isBefore(today)) {
      const diffDays = end.diff(start, "days");
      finalStart = today;
      if(end.isBefore(today)) {
        finalEnd = today.clone().add(diffDays, "days");
      }
    }

    setSelectedDate([finalStart, finalEnd]);
    setCampGetTypeValue(selectedCampaign?.offerType);
    setYValue(selectedCampaign?.offerValue);
    setProductsX(selectedCampaign?.productsX || []);
    rearrangeProducts(selectedCampaign?.productsX);
    setProductXAny(selectedCampaign?.productXAny ? "Any" : "All");
    setProductsY(selectedCampaign?.productsY || []);
    rearrangeProductsY(selectedCampaign?.productsY, selectedCampaign);
    setSegments(selectedCampaign?.segments);
    setXValue(selectedCampaign?.xValue);
    setYQuantity(selectedCampaign?.yQuantity);
    setOfferImage(selectedCampaign?.offerImage);
    setCampContentTypeValue(selectedCampaign?.contentType);
    getCreativeLineValues();
    setCampaignId(selectedCampaign?.id);
    setAnonymous(selectedCampaign?.anonymous);
    if (!Utils.IsNullOrEmpty(selectedCampaign?.offerImage)) {
      let url = selectedCampaign?.offerImage;
      const fileName = url.split("/").pop();
      const nameWithoutExt = fileName.split(".")[0];
      setOfferImageName(nameWithoutExt);
    }
  };

  const getCreativeLineValues = () => {
    if (isCustomMsg) {
      return;
    }
    setCreativeLine2(`in the next 7 days and`);
    switch (campTypeValue) {
      case CampaignTypes.Advertisement:
        setCreativeLine1("");
        break;
      case CampaignTypes.BuyXGetY:
        if (productsX.length === 1) {
          setCreativeLine1(`Buy ${XValue} ${(productsX[0].description || productsX[0].Description || productsX[0].Value || productsX[0].value)}`)
        } else if (productsX.length > 1) {
          setCreativeLine1(`Buy ${XValue} from these products`);
        } else {
          setCreativeLine1(`Buy ${XValue} from`);
        }

        break;
      case CampaignTypes.SpendXGetY:
        setCreativeLine1(`Spend ${Utils.GetCurrency(XValue, countryInfo)}`);
        break;
      case CampaignTypes.VisitXGetY:
        setCreativeLine1(`Visit ${XValue} time`);
        break;
      default:
        break;
    }

    switch (campGetTypeValue) {
      case OfferTypes.Cash:
        // setCreativeLine3("Get $ 0");
        setCreativeLine3(`Get ${Utils.GetCurrency(YValue, countryInfo)}`);
        setCreativeLine4("cash");
        break;
      case OfferTypes.Free:
        setCreativeLine3(`Get ${YValue ? YValue : ""} Free`);
        if (productsY.length === 1) {
          setCreativeLine4(`${(productsY[0].description || productsY[0].Description || productsY[0].Value || productsY[0].value)}`);
        } else if (productsY.length > 1) {
          setCreativeLine4(`from these products`)
        } else {
          setCreativeLine4("from")
        }
        break;
      case OfferTypes.Multiplier:
        setCreativeLine3(`Get ${YValue}x`);
        setCreativeLine4("points");
        break;
      case OfferTypes.PercentDiscount:
        setCreativeLine3(`Get ${YValue}% Off`);
        if (productsY.length > 1) {
          setCreativeLine4("from these products");
        } else if (productsY.length === 1) {
          setCreativeLine4(productsY[0].description || productsY[0].Description || productsY[0].Value || productsY[0].value)
        } else {
          setCreativeLine4("discount");
        }

        break;
      case OfferTypes.Points:
        setCreativeLine3(`Get ${YValue}`);
        setCreativeLine4("bonus points");
        break;
      default:
        break;
    }
  };

  const handleProductXAny = (e) => {
    if(!isLoading) {
      setProductXAny(e.target.value);
    }
  };

  const onDateChange = (date) => {
    if (!Utils.IsNullOrEmptyArray(date) && !isLoading) {
      var dateArray = [moment(date[0]), moment(date[1])];
      if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
        setMsgText("Please select a valid date range.");
        setMsgOpen(true);
      } else {
        const today = moment().startOf("day");
        let dateDiff = dateArray[1].diff(dateArray[0], "days");

        if (dateArray[0].isBefore(today) || dateArray[1].isBefore(today)) {
          setMsgText("Selected dates cannot be earlier than today.");
          setMsgOpen(true);
        } else {
          if (dateDiff > MaxDateLimit) {
            setMsgText(
              "The maximum date range is 90 days."
            );

            setMsgOpen(true);
          } else {
            setSelectedDate(dateArray);
          }
        }
      }
    }
  };

  const checkDetailsFilled = () => {
    var isDetailsFilled = true;
    let msgtext = "";
    if (Utils.IsNullOrEmpty(campaignName)) {
      msgtext += "Enter campaign name<br/>";
      isDetailsFilled = false;
    }
    if (campContentTypeValue === CampaignContentType.BannerImage && Utils.IsNullOrEmpty(offerImage)) {
      msgtext += "Choose image file<br/>"
      isDetailsFilled = false;
    }
    if (campTypeValue === CampaignTypes.BuyXGetY && productsX.length < 1) {
      msgtext += "Select products in DO-X<br/>"
      isDetailsFilled = false;
    }
    if ((campTypeValue === CampaignTypes.BuyXGetY || campTypeValue === CampaignTypes.SpendXGetY || campTypeValue === CampaignTypes.VisitXGetY) && Utils.IsNullOrEmpty(XValue)) {
      msgtext += "Enter a valid value for D0-X<br/>"
      isDetailsFilled = false;
    }
    if (campTypeValue !== CampaignTypes.Advertisement && Utils.IsNullOrEmpty(YValue)) {
      msgtext += "Enter a valid value for GET-Y<br/>"
      isDetailsFilled = false;
    }
    if (campTypeValue === CampaignTypes.BuyXGetY && campGetTypeValue === OfferTypes.PercentDiscount && Utils.IsNullOrEmpty(YQuantity)) {
      msgtext += "Fill count value in GET-Y<br/>"
      isDetailsFilled = false;
    }
    if (campTypeValue === CampaignTypes.BuyXGetY &&
      campGetTypeValue === OfferTypes.PercentDiscount &&
      (Utils.IsNullOrEmptyObject(discountProducts) ||
        !Object.values(discountProducts).some(arr => Array.isArray(arr) && arr.length > 0))) {
      msgtext += "Select products in GET-Y<br/>"
      isDetailsFilled = false;
    }
    if (campTypeValue !== CampaignTypes.Advertisement &&
      campGetTypeValue === OfferTypes.Free &&
      (Utils.IsNullOrEmptyObject(freeProducts) || freeProducts[ClassificationTypes.Item].length < 1)
    ) {
      msgtext += "Select products in GET-Y<br/>"
      isDetailsFilled = false;
    }
    if (campContentTypeValue === CampaignContentType.HtmlContent &&
      Utils.IsNullOrEmpty(creativeContent)) {
      msgtext += "Html code cannot be empty<br/>";
      isDetailsFilled = false;
    }
    if (!isDetailsFilled) {
      setMsgText(msgtext);
      setMsgOpen(true);
    }
    return isDetailsFilled

    //campaignName
  }

  const getAllProductsData = async () => {
    setIsLoading(true);
    let result1 = await loadProductsFromServer();
    if (result1.error) {
      setMsgOpen(true);
      setMsgText(result1.errorMessage);
    } else {
      if (!Utils.IsNullOrEmptyArray(result1.data)) {
        setAllProducts(result1.data);
        setFilteredAllProducts(result1.data);
        const temTypellist = [];
        const temCatllist = [];
        const campaignTypelist = [];
        const campaignCatlist = [];
        result1.data.forEach((element) => {
          if (
            !Utils.IsNullOrEmpty(element.fineline) &&
            !temTypellist.includes(element.fineline)
          ) {
            let obj = {
              department: element.fineline,
              departmentDescription: element.finelineDescription || "",
            };
            temTypellist.push(element.fineline);
            campaignTypelist.push(obj);
          }
          if (
            !Utils.IsNullOrEmpty(element.department) &&
            !temTypellist.includes(element.department)
          ) {
            let obj = {
              department: element.department,
              departmentDescription: element.departmentDescription || "",
            };
            temTypellist.push(element.department);
            campaignTypelist.push(obj);
          }
          if (
            !Utils.IsNullOrEmpty(element.class) &&
            !temCatllist.includes(element.class)
          ) {
            let obj = {
              class: element.class,
              classDescription: element.classDescription || "",
            };
            campaignCatlist.push(obj);
            temCatllist.push(element.class);
          }
        });
        setAllCatogories(campaignCatlist);
        setAllDepartments(campaignTypelist);
        setFilteredAllCategories(campaignCatlist);
        setFilteredAllDepartments(campaignTypelist);
      }
    }

    setIsLoading(false);
  };

  const handleCampaignType = (event) => {
    if(!isLoading) {
       setCampTypeValue(event.target.value);
       if(event.target.value === CampaignTypes.Advertisement) {
        setCreativeLine1("");
        setCreativeLine2("");
        setCreativeLine3("");
        setCreativeLine4("");
        setIsCustomMsg(true);
        setIsSmsInclude(false);
       } else {
        getCreativeLineValues();
        setIsCustomMsg(false);
       }
      if (CampaignTypes.BuyXGetY || CampaignTypes.VisitXGetY) {
        let newValue =  Math.floor(Number(XValue))
                        .toString()
                        .slice(0, 3);
        setXValue(newValue);
      }
      if(event.target.value === CampaignTypes.VisitXGetY && XValue >=2) {
        setAnonymous(false);
      }
    }
  };

  const trimBeforeDecimal = (value) => {
    if (!value) return value.toString();

    const strValue = value.toString();
    const [intPart, decimalPart] = strValue.split(".");

    // Keep only first 2 digits of integer part
    const trimmedInt = intPart.slice(0, 2);

    // Recombine with decimal if exists
    return decimalPart ? `${trimmedInt}.${decimalPart}` : trimmedInt;
  };

  const handleCampaignGetType = (event) => {
    if(isLoading) return
    let value = event.target.value;
    setCampGetTypeValue(value);
    if (value === OfferTypes.Free || value === OfferTypes.Multiplier || value === OfferTypes.Points) {
      let newValue = Math.floor(Number(YValue))
                        .toString()
                        .slice(0, 3);
      setYValue(newValue);
    }
    if (value === OfferTypes.PercentDiscount) {
      let newValue = parseFloat(trimBeforeDecimal(YValue));
      setYValue(newValue);
    }
    if(value === OfferTypes.Points || value === OfferTypes.Multiplier) {
      setAnonymous(false);
    }
  };

  const handleCampaignContentType = (event) => {
    if(!isLoading) {
      setCampContentTypeValue(event.target.value);
    }
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const UploadBannerImage = async (event) => {
    if(isLoading) return;
    var file = event.target.files[0];
    if (!file) {
      return
    }
    if (!file.type.startsWith("image/")) {
      setMsgOpen(true);
      setMsgText("Please upload a valid image file .");
      event.target.value = ""; // clear invalid file
      return;
    }
    if (file.type === "image/gif") {
      setMsgOpen(true);
      setMsgText("Please upload a valid image file (GIFs are not allowed).");
      event.target.value = ""; // clear invalid file
      return;
    }
    setOfferImageName(file.name);
    if (file.size > MaxFileSizeLimit) {
      setMsgText(
        "Unable to upload. File size exceeds the maximum limit, please ensure that it's less than 10 MB."
      );
      setMsgOpen(true);
      return;
    }
    var base64 = await convertBase64(file);
    setOfferImage(base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleMsgClose = () => {
    setMsgOpen(false);
    if (isNavigateToAllCampaigns) {
      navigate(CampaignsPage.Path);
    }
  };

  const handleCloseOfferImage = () => {
    if(isLoading) return
    setOfferImage("");
    setOfferImageName("");
  };

  const handleBuyRadioChange = (e) => {
    setBuyRadioSelect(e.target.value);
  };

  const handleDiscountRadioChange = (e) => {
    setDiscountRadioSelect(e.target.value);
  };

  const handleBuyProductSelect = (e, product, radioType) => {
    let allBuyProducts = { ...buyProducts };
    switch (radioType) {
      case ClassificationTypes.Class:
        allBuyProducts[ClassificationTypes.Department] = [];
        allBuyProducts[ClassificationTypes.Item] = [];
        break;
      case ClassificationTypes.Department:
        allBuyProducts[ClassificationTypes.Class] = [];
        allBuyProducts[ClassificationTypes.Item] = [];
        break;
      case ClassificationTypes.Item:
        allBuyProducts[ClassificationTypes.Class] = [];
        allBuyProducts[ClassificationTypes.Department] = [];
        break;
      default:
        break;
    }
    if (e.target.checked) {
      let buyProduct = allBuyProducts[radioType] || [];
      buyProduct.push(product);
      setBuyProducts({ ...allBuyProducts, [radioType]: buyProduct });
    } else {
      let buyProduct = { ...allBuyProducts };
      let filterProduct = buyProduct[radioType].filter((p) => p !== product);
      buyProduct[radioType] = filterProduct;
      setBuyProducts(buyProduct);
    }
  };

  const handleDiscountProductSelect = (e, product, radioType) => {
    let allDiscountProducts = { ...discountProducts };
    switch (radioType) {
      case ClassificationTypes.Class:
        allDiscountProducts[ClassificationTypes.Department] = [];
        allDiscountProducts[ClassificationTypes.Item] = [];
        break;
      case ClassificationTypes.Department:
        allDiscountProducts[ClassificationTypes.Class] = [];
        allDiscountProducts[ClassificationTypes.Item] = [];
        break;
      case ClassificationTypes.Item:
        allDiscountProducts[ClassificationTypes.Class] = [];
        allDiscountProducts[ClassificationTypes.Department] = [];
        break;
      default:
        break;
    }
    if (e.target.checked) {
      let discountProduct = allDiscountProducts[radioType] || [];
      discountProduct.push(product);
      setDiscountProducts({
        ...allDiscountProducts,
        [radioType]: discountProduct,
      });
    } else {
      let discountProduct = { ...allDiscountProducts };
      let filterProduct = discountProduct[radioType].filter(
        (p) => p !== product
      );
      discountProduct[radioType] = filterProduct;
      setDiscountProducts(discountProduct);
    }
  };

  const handleFreeProductSelect = (e, product, radioType) => {
    let allFreeProducts = { ...freeProducts };
    switch (radioType) {
      case ClassificationTypes.Class:
        allFreeProducts[ClassificationTypes.Department] = [];
        allFreeProducts[ClassificationTypes.Item] = [];
        break;
      case ClassificationTypes.Department:
        allFreeProducts[ClassificationTypes.Class] = [];
        allFreeProducts[ClassificationTypes.Item] = [];
        break;
      case ClassificationTypes.Item:
        allFreeProducts[ClassificationTypes.Class] = [];
        allFreeProducts[ClassificationTypes.Department] = [];
        break;
      default:
        break;
    }
    if (e.target.checked) {
      let freeProduct = allFreeProducts[radioType] || [];
      freeProduct.push(product);
      setFreeProducts({ ...allFreeProducts, [radioType]: freeProduct });
    } else {
      let freeProduct = { ...allFreeProducts };
      let filterProduct = freeProduct[radioType].filter((p) => p !== product);
      freeProduct[radioType] = filterProduct;
      setFreeProducts(freeProduct);
    }
  };

  const handleAddBuySelected = () => {
    switch (buyRadioSelect) {
      case ClassificationTypes.Class:
        if (!Utils.IsNullOrEmptyArray(buyProducts[ClassificationTypes.Class])) {
          let productsx = [];
          buyProducts[ClassificationTypes.Class].forEach((item) => {
            let selectedCategory = allCategories.find((c) => c.class === item);
            if (selectedCategory) {
              let obj = {
                Category: ClassificationTypes.Class,
                Value: selectedCategory.class,
                Description: selectedCategory.classDescription,
                Quantity: 0,
              };
              productsx.push(obj);
            }
          });
          setProductsX(productsx);
        }
        break;
      case ClassificationTypes.Department:
        if (
          !Utils.IsNullOrEmptyArray(buyProducts[ClassificationTypes.Department])
        ) {
          let productsx = [];
          buyProducts[ClassificationTypes.Department].forEach((item) => {
            let selectedDeptartment = allDepartments.find(
              (c) => c.department === item
            );
            if (selectedDeptartment) {
              let obj = {
                Category: ClassificationTypes.Department,
                Value: selectedDeptartment.department,
                Description: selectedDeptartment.departmentDescription,
                Quantity: 0,
              };
              productsx.push(obj);
            }
          });
          setProductsX(productsx);
        }
        break;
      case ClassificationTypes.Item:
        if (!Utils.IsNullOrEmptyArray(buyProducts[ClassificationTypes.Item])) {
          let productsx = [];
          buyProducts[ClassificationTypes.Item].forEach((item) => {
            let selectedProduct = allProducts.find((c) => c.id === item);
            if (selectedProduct) {
              let obj = {
                Category: ClassificationTypes.Item,
                Value: selectedProduct.id,
                Description: selectedProduct.shortDesc,
                Quantity: 0,
              };
              productsx.push(obj);
            }
          });
          setProductsX(productsx);
        }
        break;
      default:
        break;
    }
    handleCloseBuyProducts();
    emptySearchValues();
  };

  const rearrangeProducts = (products) => {
    let allBuyProducts = { ...buyProducts };
    if (!Utils.IsNullOrEmptyArray(products)) {
      products.forEach((product) => {
        let buyProduct = allBuyProducts[product?.category] || [];
        buyProduct.push(product?.value);
        allBuyProducts = { ...buyProducts, [product?.category]: buyProduct };
      })
    }
    setBuyProducts(allBuyProducts);
  }

  const rearrangeProductsY = (products, selectedCampaign) => {
    let allDiscountProducts = { ...discountProducts };
    let allFreeProducts = { ...freeProducts };
    if (!Utils.IsNullOrEmptyArray(products) && !Utils.IsNullOrEmptyObject(selectedCampaign)) {
      if (selectedCampaign?.offerType === OfferTypes.PercentDiscount) {
        products.forEach((product) => {
          let buyProduct = allDiscountProducts[product?.category] || [];
          buyProduct.push(product?.value);
          allDiscountProducts = { ...buyProducts, [product?.category]: buyProduct };
        })
        setDiscountProducts(allDiscountProducts);
      } else if (selectedCampaign?.offerType === OfferTypes.Free) {
        products.forEach((product) => {
          let buyProduct = allFreeProducts[product?.category] || [];
          buyProduct.push(product?.value);
          allFreeProducts = { ...buyProducts, [product?.category]: buyProduct };
        })
        setFreeProducts(allFreeProducts);
      }
    }
  }

  const handleAddDiscountSelected = () => {
    switch (discountRadioSelect) {
      case ClassificationTypes.Class:
        if (
          !Utils.IsNullOrEmptyArray(discountProducts[ClassificationTypes.Class])
        ) {
          let productsy = [];
          discountProducts[ClassificationTypes.Class].forEach((item) => {
            let selectedCategory = allCategories.find((c) => c.class === item);
            if (selectedCategory) {
              let obj = {
                Category: ClassificationTypes.Class,
                Value: selectedCategory.class,
                Description: selectedCategory.classDescription,
                Quantity: 0,
              };
              productsy.push(obj);
            }
          });
          setProductsY(productsy);
        }
        break;
      case ClassificationTypes.Department:
        if (
          !Utils.IsNullOrEmptyArray(
            discountProducts[ClassificationTypes.Department]
          )
        ) {
          let productsy = [];
          discountProducts[ClassificationTypes.Department].forEach((item) => {
            let selectedDeptartment = allDepartments.find(
              (c) => c.department === item
            );
            if (selectedDeptartment) {
              let obj = {
                Category: ClassificationTypes.Department,
                Value: selectedDeptartment.department,
                Description: selectedDeptartment.departmentDescription,
                Quantity: 0,
              };
              productsy.push(obj);
            }
          });
          setProductsY(productsy);
        }
        break;
      case ClassificationTypes.Item:
        if (
          !Utils.IsNullOrEmptyArray(discountProducts[ClassificationTypes.Item])
        ) {
          let productsy = [];
          discountProducts[ClassificationTypes.Item].forEach((item) => {
            let selectedProduct = allProducts.find((c) => c.id === item);
            if (selectedProduct) {
              let obj = {
                Category: ClassificationTypes.Item,
                Value: selectedProduct.id,
                Description: selectedProduct.shortDesc,
                Quantity: 0,
              };
              productsy.push(obj);
            }
          });
          setProductsY(productsy);
        }
        break;
      default:
        break;
    }
    setFreeProducts({});
    handleCloseDiscountProducts();
  };

  const handleAddFreeSelected = () => {
    if (!Utils.IsNullOrEmptyArray(freeProducts[ClassificationTypes.Item])) {
      let productsy = [];
      freeProducts[ClassificationTypes.Item].forEach((item) => {
        let selectedProduct = allProducts.find((c) => c.id === item);
        if (selectedProduct) {
          let obj = {
            Category: ClassificationTypes.Item,
            Value: selectedProduct.id,
            Description: selectedProduct.shortDesc,
            Quantity: 0,
          };
          productsy.push(obj);
        }
      });
      setProductsY(productsy);
    }
    setDiscountProducts({})
    handleCloseFreeProducts();
  };

  const handleChannelChange = (e, channelType) => {
    if(isLoading) return
    if (e.target.checked && channelType !== channelEnumTypes.SMS) {
      setChannels([...channels, channelType]);
      if (channelType === channelEnumTypes.SMS) {
        setIsSmsInclude(e.target.checked);
      }
    } else if (channelType === channelEnumTypes.SMS && !isCustomMsg) {
      setChannels([...channels, channelType]);
      if (channelType === channelEnumTypes.SMS) {
        setIsSmsInclude(e.target.checked);
      }
    } else {
      setChannels([...channels].filter((c) => c !== channelType));
      if (channelType === channelEnumTypes.SMS) {
        setIsSmsInclude(false);
      }
    }
  };

  const handleCustomToggle = (e) => {
    if(isLoading) return
    setIsCustomMsg(e.target.checked);
    if (e.target.checked) {
      setMsgOpen(true);
      setMsgText(
        "Please note that the Infopoint application do not support sending custom campaign messages due to Telecom Regulatory Authority of India's regulations. Please contact Infopoint support team for more information."
      );
      setIsSmsInclude(false);
      setChannels([...channels].filter((c) => c !== channelEnumTypes.SMS));
    }
  };

  const handleTierChange = (e, i) => {    
    if(isLoading) return
    let newTierList = [...tiersList];
    newTierList[i].isChecked = e.target.checked;
    setTiersList(newTierList);
    if (e.target.checked) {
      let updatedTiers = [...selectedTiers, e.target.value];
      setSelectedTiers(updatedTiers);
      let obj = {
        Type: CampaignSegmentTypes.Tier,
        Value: e.target.value,
      };
      setSegments([...segments, obj]);
    } else {
      let updatedTiers = [...selectedTiers].filter((t) => t !== e.target.value);
      setSelectedTiers(updatedTiers);
      let updatedSegments = segments.filter(
        (s) =>
          !(s.Type === CampaignSegmentTypes.Tier && s.Value === e.target.value)
      );
      setSegments(updatedSegments);
    }
  };

  const handleLocationChange = (e, count, location, i) => {
    const checked = e.target.checked;

     // Find real index in original list
      const index = locationsList.findIndex(
        (loc) => loc.name === location.name
      );

    let newLocationsList = [...locationsList];
    newLocationsList[index].isChecked = checked;
    setLocationsList(newLocationsList);
    if (checked) {
      let updatedLocation = [...selectedLocations, e.target.value];
      setSelectedLocations(updatedLocation);
      let obj = {
        Type: CampaignSegmentTypes.Location,
        Value: e.target.value,
      };
      setSegments([...segments, obj]);

      setTiersList((prevTiersList) =>
        prevTiersList.map((tier) => {
          const locationTier = location.tiers[0];
          if (tier.level === locationTier.level) {
            return {
              ...tier,
              locationTierCount:
                (tier.locationTierCount || 0) +
                (locationTier.customerCount || 0),
            };
          }
          return tier;
        })
      );
    } else {
      let updatedLocation = [...selectedLocations].filter(
        (t) => t !== e.target.value
      );
      setSelectedTiers(updatedLocation);
      let updatedSegments = segments.filter(
        (s) =>
          !(
            s.Type === CampaignSegmentTypes.Location &&
            s.Value === e.target.value
          )
      );
      setSegments(updatedSegments);
      setTiersList((prevTiersList) =>
        prevTiersList.map((tier) => {
          const locationTier = location.tiers[0];
          if (tier.level === locationTier.level) {
            return {
              ...tier,
              locationTierCount:
                (tier.locationTierCount || 0) -
                (locationTier.customerCount || 0),
            };
          }
          return tier;
        })
      );
    }
    handleSearchLocation(searchLocationValue);
  };

  const getImgObj = (selectedUrl) => {
    return {
      url: Utils.IsNullOrEmpty(selectedUrl)
        ? ""
        : selectedUrl.startsWith("http")
          ? selectedUrl
          : Utils.GetStringFromBase64(selectedUrl),
      newFile:
        !Utils.IsNullOrEmpty(selectedUrl) && !selectedUrl.startsWith("http"),
    };
  };
  const onClickCancel = async () => {
    navigate(CampaignsPage.Path);
  };

  const handleSaveCampaign = async () => {
    let isDetailsFilled = checkDetailsFilled();
    let newCustomerCount = customerCount;
    let newSegments = segments;
    if (isDetailsFilled) {
      if(customerCount === 0) {
        tiersList.forEach((tier,index) => {
          newCustomerCount += tier?.customerCount || 0;
          let obj = {
            Type: CampaignSegmentTypes.Tier,
             Value: index+1,
          }
          newSegments = [...newSegments,obj]
        })
      }
      const OfferImgObj = getImgObj(offerImage);
      let obj = {
        Anonymous: anonymous,
        BranchId: localSettings.branch.branchId,
        BusinessId: localSettings.business.businessId,
        Channels: channels.join(","),
        Creative:
          campContentTypeValue === CampaignContentType.HtmlContent
            ? creativeContent
            : "",
        CreativeIsHtml: campContentTypeValue === CampaignContentType.HtmlContent,
        CreativeIsImage: false,
        CreativeBGColor: selectedColor,
        End: selectedDate[1],
        Id: campaignId,
        Invited: newCustomerCount,
        OfferType: campGetTypeValue,
        OfferValue: YValue || 0,
        Name: campaignName,
        ProductsX: productsX,
        ProductXAny: productXAny === "Any",
        ProductsY:
          campGetTypeValue === OfferTypes.Free ||
            campGetTypeValue == OfferTypes.PercentDiscount
            ? productsY
            : [],
        Segments: newSegments,
        Start: selectedDate[0],
        Status: campaignBtnStatus === "Approve" ? "Approved" : campaignBtnStatus === "End" ? "Ended" : "Draft",
        Type: campTypeValue,
        XValue: XValue,
        YQuantity: YQuantity || 1,
        OfferImage: OfferImgObj.url,
        ContentType: campContentTypeValue,
        CreativeLine1: campContentTypeValue === CampaignContentType.HtmlContent ? creativeContent : creativeLine1,
        CreativeLine2: creativeLine2,
        CreativeLine3: creativeLine3,
        CreativeLine4: creativeLine4,
      };
      // Approved
      setIsLoading(true);
      let result = await postAsync("Campaign/Save", {
        Campaign: obj,
        Status: "Draft",
        Delete: campaignBtnStatus === "Delete",
        CampaignId: "",
        BusinessId: localSettings.business.businessId,
        BranchId: localSettings.branch.branchId,
      });
      setIsLoading(false);
      if (result && result.error) {
        setMsgOpen(true);
        setMsgText(result.errorMessage);
      } else if (result && result.data) {
        setMsgOpen(true);
        setIsNavigateToAllCampaigns(true);
        if (campaignBtnStatus === "Save") {
          setMsgText("Campaign Added Successfully");
        } else if (campaignBtnStatus === "Update") {
          setMsgText("Campaign Updated Successfully");
        } else if (campaignBtnStatus === "Delete") {
          setMsgText("Campaign Deleted Successfully");
        } else if (campaignBtnStatus === "Approve") {
          setMsgText("Campaign Approved Successfully");
        }
      }
    }

  };

  const handleOpenBuyProducts = () => {
    if(!isLoading) {
      setOpenBuyProductsModal(true);
      emptySearchValues();
    }
  };
  const handleCloseBuyProducts = () => {
    setOpenBuyProductsModal(false);
    emptySearchValues();
  };
  const emptySearchValues = () => {
    setSearchValue("");
    setFilteredAllCategories(allCategories);
    setFilteredAllDepartments(allDepartments);
    setFilteredAllProducts(allProducts);
  }

  const handleOpenDiscountProducts = () => {
    if(!isLoading) {
       setOpenDiscountProdutsModal(true);
      emptySearchValues();
    }
  };

  const handleCloseDiscountProducts = () => {
    setOpenDiscountProdutsModal(false);
  };

  const handleOpenFreeProducts = () => {
    if(!isLoading) {
    emptySearchValues();
    setOpenFreeProductsModal(true);
    if (
      !Utils.IsNullOrEmptyObject(discountProducts) &&
      !Utils.IsNullOrEmptyObject(discountProducts[ClassificationTypes.Item])
    ) {
      setFreeProducts(discountProducts);
    }
  }
  };

  const handleCloseFreeProducts = () => {
    setOpenFreeProductsModal(false);
  };

  const handletoggleNonLoyality = (e) => {
    if(isLoading || campGetTypeValue === OfferTypes.Points || campGetTypeValue === OfferTypes.Multiplier) return
    if(campTypeValue === CampaignTypes.VisitXGetY && XValue >= 2) {
      setAnonymous(false);
    } else {
      setAnonymous(e.target.checked);
    }
  };

  const fetchHtml = async (url) => {
    try {
      setIsLoading(true);
      const response = await postAsync("Campaign/GetHtmlContent", {
        blobUrl: url
      });
      setIsLoading(false);
      if (response?.text) {
        setCreativeContent(response.text.trim());
      }
    } catch (error) {
      setMsgOpen(true);
      setMsgText(error);
    }
  };

  const handleSearchProducts = (searchValue, selected) => {
    setSearchValue(searchValue);
    if (selected === ClassificationTypes.Class) {

      const filteredData = allCategories.filter(item => {
        const search = searchValue.toLowerCase();
        return (
          item.class?.toLowerCase().includes(search) ||
          item.classDescription?.toLowerCase().includes(search)
        )
      })
      setFilteredAllCategories(filteredData);
      if (Utils.IsNullOrEmpty(searchValue)) {
        setFilteredAllCategories(allCategories);
      }
    }
    if (selected === ClassificationTypes.Department) {
      const filteredData = allDepartments.filter(item => {
        const search = searchValue.toLowerCase();
        return (
          item.department?.toLowerCase().includes(search) ||
          item.departmentDescription?.toLowerCase().includes(search)
        )
      })
      setFilteredAllDepartments(filteredData);
      if (Utils.IsNullOrEmpty(searchValue)) {
        setFilteredAllDepartments(allDepartments);
      }
    }
    if (selected === ClassificationTypes.Item) {
      const filteredData = allProducts.filter(item => {
        const search = searchValue.toLowerCase();
        return (
          item.shortDesc?.toLowerCase().includes(search) ||
          item.description?.toLowerCase().includes(search)
        )
      })
      setFilteredAllProducts(filteredData);
      if (Utils.IsNullOrEmpty(searchValue)) {
        setFilteredAllProducts(allProducts);
      }
    }
  }

  const handleClick = () => {
    // Trigger hidden file input
    fileInputRef.current.click();
  };

  const handleSearchLocation = (value) => {
    if(isLoading) return
      setSearchLocationValue(value);

      if (!value) {
        // No search → show full list
        setFilteredLocationsList(locationsList);
        return;
      }

      const lower = value.toLowerCase();

      // Items matching search
      const matched = locationsList.filter((loc) =>
        loc.name.toLowerCase().includes(lower)
      );

      // Checked items (always visible)
      const checked = locationsList.filter((loc) => loc.isChecked);

      // Merge but avoid duplicates
      const merged = [
        ...checked,
        ...matched.filter((loc) => !checked.includes(loc)),
      ];

      setFilteredLocationsList(merged);
    };



  return (
    <Container maxWidth="false" className="bg-color p-0 setting-page">
      <Grid className="container">
        <Grid container m={0}>
          <Loader open={isLoading} />
          <MessagePopup
            msgOpen={msgOpen}
            msgText={msgText}
            onMsgClose={handleMsgClose}
          />
          <SideBarMenuItems selectedTab={SideBarMenuNames.Campaigns} />

          <Typography
            level="h2"
            component="h2"
            fontWeight="600"
            fontSize="2rem"
            className="page-title text-center"
            marginTop={2}
          >
            <Button onClick={onClickCancel} className="back-btn">
              <NavigateBeforeIcon />
            </Button>
            Campaign
          </Typography>
          <Grid
            xs={12}
            className="content-sec"
            style={{ "padding-bottom": "80px" }}
          >
            <Stack mt={3} direction="row" spacing={1}>
              <TextField
                className="page-title"
                placeholder="Enter campaign name"
                InputLabelProps={{ shrink: true }}
                disabled={isProcessing}
                multiline="true"
                sx={{ flex: 1 }}
                value={campaignName}
                error={!campaignName}
                onChange={(e) => {
                  const text = e.target.value;
                  if(text.length <= 30 && !isLoading) {
                    setCampaignName(e.target.value)
                  }
                }}
              />
              <Box
                className="card"
                sx={{
                  width: "234px",
                  padding: "8px",
                  "border-color": "rgba(0, 0, 0, 0.23)",
                  "text-align": "center",
                }}
              >
                <DateRangePicker
                  showLeadingZeros={true}
                  disabled={isProcessing}
                  minDate={new Date()}
                  value={selectedDate}
                  onChange={onDateChange}
                  locale={CountryHelper.GetDateCulture(getCountry().Culture)}
                  clearIcon={null}
                  calendarIcon={
                    <CalendarMonthOutlinedIcon
                      style={{
                        "font-size": "24px",
                        "align-self": "center",
                        color: "#666666",
                      }}
                    />
                  }
                />
              </Box>
            </Stack>

            <Grid container direction="row" spacing={4}>
              <Grid item xs={12} sm={7} md={7} flex="1" spacing={2}>
                <Grid className="mt-2">
                  <Stack spacing={2} rowGap={1} className="mt-2">
                    <Typography
                      level="h3"
                      component="h3"
                      fontSize="1.8rem"
                      fontWeight="600"
                      justifyContent="space-between"
                      display="flex"
                      alignItems="center"
                    >
                      <span>Campaign Type</span>
                      {
                        // if not Ad
                        campTypeValue !== CampaignTypes.Advertisement && (
                          <span>DO-X</span>
                        )
                      }
                    </Typography>
                    <FormControl className="font-size-14 m-0">
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={CampaignTypes.SpendXGetY}
                        name="radio-buttons-group"
                        sx={{ flexDirection: "row" }}
                        value={campTypeValue}
                        onChange={handleCampaignType}
                      >
                        <FormControlLabel
                          value={CampaignTypes.Advertisement}
                          control={<Radio />}
                          label="Ad"
                          disabled={isReadOnlyCampaign}
                        />
                        <FormControlLabel
                          value={CampaignTypes.BuyXGetY}
                          control={<Radio />}
                          label="Buy"
                          disabled={isReadOnlyCampaign}
                        />
                        <FormControlLabel
                          value={CampaignTypes.SpendXGetY}
                          control={<Radio />}
                          label="Spend"
                          disabled={isReadOnlyCampaign}
                        />
                        <FormControlLabel
                          value={CampaignTypes.VisitXGetY}
                          control={<Radio />}
                          label="Visit"
                          disabled={isReadOnlyCampaign}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Stack>

                  {
                    // Buy
                    campTypeValue === CampaignTypes.BuyXGetY && (
                      <Stack
                        className="font-size-14"
                        spacing={1}
                        direction="row"
                      >
                        <NumericTextField
                          type="text"
                          label="Count"
                          name="buyCount"
                          sx={{ width: "200px" }}
                          disabled={isReadOnlyCampaign}
                          value={XValue}
                          error={!XValue}
                          inputProps={{ maxLength: 3 }}
                          maxLengthValue={3}
                          setValue={(value) => {
                            let newValue = parseFloat(value) || 0;
                            if(!isLoading) {
                              setXValue(newValue);
                            }
                          }}
                          InputProps={{ inputProps: { min: 1 } }}
                        />
                        <Button
                          onClick={handleOpenBuyProducts}
                          className="btn btn-secondary"
                          sx={{ flex: 1, height: "53px" }}
                        >
                          {Utils.IsNullOrEmptyArray(productsX)
                            ? "Select Items"
                            : productsX.length === 1
                              ? (productsX[0].Description || productsX[0].description || productsX[0].shortDesc || productsX[0].ShortDesc || productsX[0].Value)
                              : `${productsX.length} Items Selected`}
                        </Button>
                        <ProductSelectionModal
                          open={openBuyProductsModal}
                          onClose={handleCloseBuyProducts}
                          title="Select Items"
                          showRadioGroup
                          radioValue={buyRadioSelect}
                          isReadOnlyCampaign={isReadOnlyCampaign}
                          onRadioChange={handleBuyRadioChange}
                          searchValue={searchValue}
                          onSearchChange={handleSearchProducts}
                          filteredCategories={filteredAllCategories}
                          filteredDepartments={filteredAllDepartments}
                          filteredProducts={filteredAllProducts}
                          productsSelection={buyProducts}
                          onCheckboxChange={handleBuyProductSelect}
                          classificationTypes={ClassificationTypes}
                          addButtonDisabled={Utils.IsNullOrEmptyArray(buyProducts[buyRadioSelect])}
                          onAddClick={handleAddBuySelected}
                        />
                      </Stack>
                    )
                  }

                  {
                    // Spend
                    campTypeValue === CampaignTypes.SpendXGetY && (
                      <Stack className="font-size-14">
                        <DecimalEntryField
                          type="number"
                          label="Amount"
                          name="spendAmount"
                          value={XValue}
                          setError={isEmptyOrZero(XValue)}
                          disabled={isReadOnlyCampaign}
                          inputProps={{ maxLength: 5 }}
                          maxLengthValue={7}
                          stopText={isLoading}
                          setValue={(value) => {
                            if(!isLoading) {
                              setXValue(value);
                            }
                          }}
                          InputProps={{ inputProps: { min: 1 } }}
                        />
                      </Stack>
                    )
                  }

                  {
                    // Visit
                    campTypeValue === CampaignTypes.VisitXGetY && (
                      <Stack className="font-size-14">
                        <NumericTextField
                          type="text"
                          label="No of times"
                          value={XValue}
                          error={!XValue}
                          disabled={isReadOnlyCampaign}
                          inputProps={{ maxLength: 3 }}
                          maxLengthValue={3}
                          setValue={(value) => {
                            let newValue = parseFloat(value) || 0;
                            if(!isLoading) {
                              setXValue(newValue);
                            }
                            if(newValue >=2) {
                              setAnonymous(false);
                            }
                          }}
                          name="visitTimes"
                          InputProps={{ inputProps: { min: 1 } }}
                        />
                      </Stack>
                    )
                  }

                  {campTypeValue === CampaignTypes.BuyXGetY &&
                    productsX?.length > 1 && (
                      <FormControl className="font-size-14">
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          name="radio-buttons-group"
                          sx={{ flexDirection: "row" }}
                          value={productXAny}
                          onChange={handleProductXAny}
                        >
                          <FormControlLabel
                            value="All"
                            control={<Radio />}
                            label="All"
                            disabled={isReadOnlyCampaign}
                          />
                          <FormControlLabel
                            value="Any"
                            control={<Radio />}
                            label="Any"
                            disabled={isReadOnlyCampaign}
                          />
                        </RadioGroup>
                      </FormControl>
                    )}

                  {
                    // if not Ad
                    campTypeValue !== CampaignTypes.Advertisement && (
                      <Stack>
                        <Typography
                          level="h3"
                          component="h3"
                          fontSize="1.8rem"
                          fontWeight="600"
                          justifyContent="end"
                          display="flex"
                          alignItems="center"
                          marginTop="1rem"
                        >
                          <span>GET-Y</span>
                        </Typography>
                        <FormControl className="font-size-14">
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={OfferTypes.PercentDiscount}
                            name="radio-buttons-group"
                            sx={{ flexDirection: "row" }}
                            value={campGetTypeValue}
                            onChange={handleCampaignGetType}
                          >
                            <FormControlLabel
                              value={OfferTypes.Cash}
                              control={<Radio />}
                              label="Cash"
                              disabled={isReadOnlyCampaign}
                            />
                            <FormControlLabel
                              value={OfferTypes.PercentDiscount}
                              control={<Radio />}
                              label="Discount %"
                              disabled={isReadOnlyCampaign}
                            />
                            <FormControlLabel
                              value={OfferTypes.Free}
                              control={<Radio />}
                              label="Free"
                              disabled={isReadOnlyCampaign}
                            />
                            <FormControlLabel
                              value={OfferTypes.Points}
                              control={<Radio />}
                              label="Points"
                              disabled={isReadOnlyCampaign}
                            />
                            <FormControlLabel
                              value={OfferTypes.Multiplier}
                              control={<Radio />}
                              label="Points Multiplier"
                              disabled={isReadOnlyCampaign}
                            />
                          </RadioGroup>
                        </FormControl>
                      </Stack>
                    )
                  }

                  {
                    // if Buy
                    campTypeValue !== CampaignTypes.Advertisement && (
                      <>
                        {campGetTypeValue === OfferTypes.Cash && (
                          <Stack className="font-size-14" spacing={1}>
                            <DecimalEntryField
                              type="number"
                              label="Amount"
                              name="getCashAmount"
                              placeholder="0"
                              value={YValue}
                              setError={!YValue}
                              disabled={isReadOnlyCampaign}
                              inputProps={{ maxLength: 5 }}
                              maxLengthValue={7}
                              setValue={(value) => {
                                let newValue = parseFloat(value) || 0;
                                if(isLoading) return
                                setYValue(newValue);
                              }}
                              InputProps={{ inputProps: { min: 1 } }}
                            />
                          </Stack>
                        )}

                        {campTypeValue === CampaignTypes.BuyXGetY && (
                          <>
                            {campGetTypeValue ===
                              OfferTypes.PercentDiscount && (
                                <Stack
                                  className="font-size-14"
                                  spacing={1}
                                  direction="row"
                                >
                                  <FormControl>
                                    <DecimalEntryField
                                      type="number"
                                      label="Discount"
                                      name="getDiscountValue"
                                      stopText={isLoading}
                                      value={YValue}
                                      setError={!YValue}
                                      disabled={isReadOnlyCampaign}
                                      maxLengthValue={2}
                                      setValue={(value) => {
                                        if(!isLoading) {
                                          setYValue(Number(value));
                                        }
                                        
                                      }}
                                      sx={{ width: "200px" }}
                                      inputProps={{ maxLength: 5 }}
                                      placeholder="0% Offer"
                                    />
                                  </FormControl>
                                  <FormControl>
                                    <NumericTextField
                                      type="text"
                                      label="Count"
                                      name="buyCount"
                                      sx={{ width: "200px" }}
                                      inputProps={{ maxLength: 5 }}
                                      maxLengthValue={7}
                                      value={YQuantity}
                                      error={!YQuantity}
                                      setValue={(value) => {
                                        let newValue = parseFloat(value) || 0;
                                        if(!isLoading) {
                                          setYQuantity(newValue);
                                        }
                                        
                                      }}
                                      InputProps={{ inputProps: { min: 1 } }}
                                    />
                                  </FormControl>
                                  <Button
                                    onClick={handleOpenDiscountProducts}
                                    className="btn btn-secondary"
                                    sx={{ flex: 1, height: "53px" }}
                                  >
                                    {Utils.IsNullOrEmptyArray(productsY) || Utils.IsNullOrEmptyObject(discountProducts)
                                      ? "Select Items"
                                      : productsY.length === 1
                                        ? (productsY[0].Description || productsY[0].description || productsY[0].shortDesc || productsY[0].ShortDesc || productsY[0].Value)
                                        : `${productsY.length} Items Selected`}
                                  </Button>

                                  <ProductSelectionModal
                                    open={openDiscountProdutsModal}
                                    onClose={handleCloseDiscountProducts}
                                    title="Select Discount Items"
                                    showRadioGroup
                                    radioValue={discountRadioSelect}
                                    onRadioChange={handleDiscountRadioChange}
                                    searchValue={searchValue}
                                    onSearchChange={handleSearchProducts}
                                    filteredCategories={filteredAllCategories}
                                    filteredDepartments={filteredAllDepartments}
                                    filteredProducts={filteredAllProducts}
                                    productsSelection={discountProducts}
                                    onCheckboxChange={handleDiscountProductSelect}
                                    classificationTypes={ClassificationTypes}
                                    addButtonDisabled={Utils.IsNullOrEmptyArray(discountProducts[discountRadioSelect])}
                                    onAddClick={handleAddDiscountSelected}
                                  />
                                </Stack>
                              )}
                          </>
                        )}

                        {campTypeValue !== CampaignTypes.BuyXGetY && (
                          <>
                            {campGetTypeValue ===
                              OfferTypes.PercentDiscount && (
                                <Stack className="font-size-14" spacing={1}>
                                  <FormControl>
                                    <DecimalEntryField
                                      type="number"
                                      label="Discount"
                                      name="getDiscountValue"
                                      stopText={isLoading}
                                      disabled={isReadOnlyCampaign}
                                      maxLengthValue={2}
                                      value={YValue}
                                      setError={!YValue}
                                      inputProps={{ maxLength: 5 }}
                                      setValue={(value) => {
                                        if(!isLoading) {
                                           setYValue(Number(value));
                                        }
                                      }}
                                      placeholder="0% Offer"
                                    />
                                  </FormControl>
                                </Stack>
                              )}
                          </>
                        )}

                        {campGetTypeValue === OfferTypes.Free && (
                          <Stack
                            className="font-size-14"
                            spacing={1}
                            direction="row"
                          >
                            <NumericTextField
                              type="text"
                              label="Free"
                              name="getFreeValue"
                              sx={{ width: "200px" }}
                              inputProps={{ maxLength: 3 }}
                              disabled={isReadOnlyCampaign}
                              value={YValue}
                              error={!YValue}
                              maxLengthValue={3}
                              setValue={(value) => {
                                if(!isLoading) {
                                  setYValue(Number(value));
                                }
                              }}
                              placeholder="0"
                            />
                            <Button
                              onClick={handleOpenFreeProducts}
                              className="btn btn-secondary"
                              sx={{ flex: 1, height: "53px" }}
                            >
                              {Utils.IsNullOrEmptyArray(productsY) || Utils.IsNullOrEmptyObject(freeProducts)
                                ? "Select Items"
                                : productsY.length === 1
                                  ? (productsY[0].Description || productsY[0].description || productsY[0].shortDesc || productsY[0].ShortDesc || productsY[0].Value)
                                  : `${productsY.length} Items Selected`}
                            </Button>

                            <ProductSelectionModal
                              open={openFreeProductsModal}
                              onClose={handleCloseFreeProducts}
                              title="Select Items"
                              showRadioGroup={false} // Only shows products
                              radioValue={ClassificationTypes.Item}
                              onRadioChange={() => { }}
                              searchValue={searchValue}
                              onSearchChange={handleSearchProducts}
                              filteredProducts={filteredAllProducts}
                              productsSelection={freeProducts}
                              onCheckboxChange={handleFreeProductSelect}
                              classificationTypes={ClassificationTypes}
                              addButtonDisabled={Utils.IsNullOrEmptyArray(freeProducts[ClassificationTypes.Item])}
                              onAddClick={handleAddFreeSelected}
                            />
                          </Stack>
                        )}

                        {campGetTypeValue === OfferTypes.Points && (
                          <Stack className="font-size-14">
                            <NumericTextField
                              type="text"
                              label="Points"
                              name="getPointsValue"
                              value={YValue}
                              error={!YValue}
                              disabled={isReadOnlyCampaign}
                              inputProps={{ maxLength: 3 }}
                              maxLengthValue={3}
                              setValue={(value) => {
                                if(!isLoading) {
                                  setYValue(Number(value));
                                }
                                
                              }}
                              placeholder="0"
                            />
                          </Stack>
                        )}

                        {campGetTypeValue === OfferTypes.Multiplier && (
                          <Stack className="font-size-14" spacing={1}>
                            <NumericTextField
                              type="text"
                              label="Points Multiplier (X)"
                              name="getPointsMultiplierValue"
                              value={YValue}
                              disabled={isReadOnlyCampaign}
                              error={!YValue}
                              maxLengthValue={7}
                              setValue={(value) => {
                                if(!isLoading) {
                                  setYValue(Number(value));
                                }
                              }}
                              inputProps={{ maxLength: 5 }}
                              placeholder="0x"
                            />
                          </Stack>
                        )}
                      </>
                    )
                  }

                  {campTypeValue === CampaignTypes.Advertisement && <Stack spacing={2} rowGap={1} className="mt-2">
                    <Typography
                      level="h3"
                      component="h3"
                      fontSize="1.8rem"
                      fontWeight="600"
                      justifyContent="space-between"
                      display="flex"
                      alignItems="center"
                    >
                      <span>Content Type</span>
                    </Typography>
                    <FormControl className="font-size-14 m-0">
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={CampaignContentType.Coupon}
                        name="radio-buttons-group"
                        sx={{ flexDirection: "row" }}
                        value={campContentTypeValue}
                        onChange={handleCampaignContentType}
                      >
                        <FormControlLabel
                          value={CampaignContentType.Coupon}
                          control={<Radio />}
                          label="Coupon Content"
                          disabled={isReadOnlyCampaign}
                        />
                        <FormControlLabel
                          value={CampaignContentType.BannerImage}
                          control={<Radio />}
                          label="Banner Image"
                          disabled={isReadOnlyCampaign}
                        />
                        {/* <FormControlLabel
                          value={CampaignContentType.HtmlContent}
                          control={<Radio />}
                          label="HTML"
                        /> */}
                      </RadioGroup>
                    </FormControl>

                    {campContentTypeValue === CampaignContentType.Coupon && (
                      <FormControl className="font-size-14 m-0">
                        <Stack marginBottom={2} direction="row" spacing={2}>
                          {colors.map((color, index) => (
                            <Tooltip key={color} title={colorname[index]}>
                              <IconButton
                                onClick={(e) => {
                                  if (!isReadOnlyCampaign && !isLoading) {
                                    setSelectedColor(colorname[index])
                                  }
                                }
                                }
                                sx={{
                                  width: 35,
                                  height: 35,
                                  borderRadius: "50%",
                                  backgroundColor: color,
                                  cursor: "pointer",
                                  border:
                                    selectedColor === color
                                      ? "1px solid #333"
                                      : "1px solid #ccc",
                                  transition: "none",
                                  "&:hover": {
                                    backgroundColor: color,
                                  },
                                }}
                              />
                            </Tooltip>
                          ))}
                        </Stack>
                        {!offerImage && (
                          <TextField
                            type="file"
                            name="campImage"
                            disabled={isProcessing}
                            inputProps={{ accept: "image/*" }}
                            onChange={(e) => UploadBannerImage(e)}
                          />
                        )}
                        {offerImage && offerImageName && (
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <Typography
                              level="h2"
                              component="h2"
                              fontWeight="600"
                              fontSize="2rem"
                              alignSelf="center"
                            >
                              {offerImageName}
                            </Typography>
                            <Button
                              className="btn btn-primary align-self-start"
                              variant="contained"
                              onClick={handleCloseOfferImage}
                              disabled={isReadOnlyCampaign}
                            >
                              Delete Image
                            </Button>
                          </Stack>
                        )}
                      </FormControl>
                    )}

                    {campContentTypeValue === CampaignContentType.BannerImage &&
                      !offerImage && (
                        <FormControl className="font-size-14 m-0">
                          <TextField
                            type="file"
                            label="Image"
                            name="campImage"
                            disabled={isProcessing}
                            InputLabelProps={{
                              accept:
                                "image/png, image/jpeg, image/ico, image/jpg",
                              shrink: true,
                            }}
                            onChange={(e) => UploadBannerImage(e)}
                          />
                        </FormControl>
                      )}
                    {campContentTypeValue === CampaignContentType.BannerImage &&
                      offerImage && (
                        <Stack direction="row" alignItems="center" spacing={2}>
                          <Typography
                            level="h2"
                            component="h2"
                            fontWeight="600"
                            fontSize="1.5rem"
                            alignSelf="center"
                          >
                            {offerImageName}
                          </Typography>
                          <Button
                            className="btn btn-primary align-self-start"
                            variant="contained"
                            onClick={handleCloseOfferImage}
                          >
                            Delete Image
                          </Button>
                        </Stack>
                      )}

                    {campContentTypeValue ===
                      CampaignContentType.HtmlContent && (
                        <FormControl className="font-size-14 m-0">
                          <TextField
                            type="text"
                            multiline="true"
                            rows={5}
                            label="Html Code"
                            name="campHtml"
                            error={!creativeContent}
                            value={creativeContent}
                            onChange={(e) => setCreativeContent(e.target.value)}
                          />
                        </FormControl>
                      )}
                  </Stack>}
                </Grid>
              </Grid>
              {campContentTypeValue !== CampaignContentType.HtmlContent && (
                <Grid item xs={12} sm={5} md={5} flex="1" spacing={2}>
                  <Card
                    sx={{
                      boxShadow: "none",
                      borderRadius: "10px",
                      marginTop: "2rem",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      position: "sticky",
                      top: 0,
                      maxHeight: "270px",
                    }}
                  >
                    {!offerImage && (
                      <Typography
                        fontSize="1.5rem"
                        sx={{ position: "absolute", top: "10px", left: "20px" }}
                      >
                        Preview :
                      </Typography>
                    )}
                    <Stack direction="row" spacing={2}>
                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        hidden
                        disabled={isProcessing}
                        style={{ display: "none" }}
                        onChange={(e) => UploadBannerImage(e)}
                      />
                      <Box
                        onClick={handleClick}
                        component="img"
                        alt="Preview"
                        src={offerImage ? offerImage : Preview_Img}
                        alignSelf="Center"
                        sx={{
                          width: "246px",
                          cursor: "pointer",
                        }}
                        className="m-0"
                      />
                    </Stack>
                    {campContentTypeValue === CampaignContentType.Coupon && (
                      <Box
                        alignSelf="center"
                        spacing={0.5}
                        sx={{
                          backgroundColor: selectedColor || "white",
                          flex: 1,
                          height: "100%",
                          p: 1,
                          m: 0,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Stack alignSelf="center">
                          <Typography
                            level="h4"
                            component="h4"
                            fontWeight="600"
                            fontSize="1.2rem"
                            className="h3"
                            style={{
                              color:
                                selectedColor === "White" ? "blue" : "white",
                            }}
                          >
                            {creativeLine1?.toLowerCase().includes("from these") ? (
                              <>
                                Buy {XValue} from these{" "}
                                <span
                                  style={{ textDecoration: "underline", cursor: "pointer" }}
                                  onClick={() => {
                                    if(isLoading) return
                                    setOpenSelectedProducts(true);
                                    setSelectedProducts(productsX);
                                  }}
                                >
                                  products
                                </span>
                              </>
                            ) : (
                              <>
                                {creativeLine1}
                              </>
                            )
                            }
                          </Typography>
                          <Typography
                            level="h4"
                            component="h4"
                            fontWeight="600"
                            fontSize="1rem"
                            className="h3"
                            style={{
                              color:
                                selectedColor === "White" ? "black" : "white",
                            }}
                          >
                            {creativeLine2}
                          </Typography>
                          <Typography
                            level="h3"
                            component="h3"
                            fontWeight="600"
                            fontSize="1.5rem"
                            className="h3"
                            style={{
                              color:
                                selectedColor === "White" ? "green" : "#e8d52a",
                            }}
                          >
                            {creativeLine3}
                          </Typography>
                          <Typography
                            level="h4"
                            component="h4"
                            fontWeight="600"
                            fontSize="1.2rem"
                            className="h3"
                            style={{
                              color:
                                selectedColor === "White" ? "black" : "white",
                            }}
                          >
                            {/* {creativeLine4} */}
                            {creativeLine4?.toLowerCase().includes("from these") ? (
                              <>
                                from these{" "}
                                <span
                                  style={{ textDecoration: "underline", cursor: "pointer" }}
                                  onClick={() => {
                                    if(isLoading) return
                                    setOpenSelectedProducts(true);
                                    setSelectedProducts(productsY);
                                  }}
                                >
                                  products
                                </span>
                              </>
                            ) : (
                              <>
                                {creativeLine4}
                              </>
                            )}
                          </Typography>
                        </Stack>
                      </Box>
                    )}
                  </Card>
                </Grid>
              )}
            </Grid>
            <Box mt={4}>
                {campTypeValue !== CampaignTypes.Advertisement && <Stack spacing={2} rowGap={1} className="mt-2">
                    <Typography
                      level="h3"
                      component="h3"
                      fontSize="1.8rem"
                      fontWeight="600"
                      justifyContent="space-between"
                      display="flex"
                      alignItems="center"
                    >
                      <span>Content Type</span>
                    </Typography>
                    <FormControl className="font-size-14 m-0">
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue={CampaignContentType.Coupon}
                        name="radio-buttons-group"
                        sx={{ flexDirection: "row" }}
                        value={campContentTypeValue}
                        onChange={handleCampaignContentType}
                      >
                        <FormControlLabel
                          value={CampaignContentType.Coupon}
                          control={<Radio />}
                          label="Coupon Content"
                          disabled={isReadOnlyCampaign}
                        />
                        <FormControlLabel
                          value={CampaignContentType.BannerImage}
                          control={<Radio />}
                          label="Banner Image"
                          disabled={isReadOnlyCampaign}
                        />
                        {/* <FormControlLabel
                          value={CampaignContentType.HtmlContent}
                          control={<Radio />}
                          label="HTML"
                        /> */}
                      </RadioGroup>
                    </FormControl>

                    {campContentTypeValue === CampaignContentType.Coupon && (
                      <FormControl className="font-size-14 m-0">
                        <Stack marginBottom={2} direction="row" spacing={2}>
                          {colors.map((color, index) => (
                            <Tooltip key={color} title={colorname[index]}>
                              <IconButton
                                onClick={(e) => {
                                  if (!isReadOnlyCampaign && !isLoading) {
                                    setSelectedColor(colorname[index])
                                  }
                                }
                                }
                                sx={{
                                  width: 35,
                                  height: 35,
                                  borderRadius: "50%",
                                  backgroundColor: color,
                                  cursor: "pointer",
                                  border:
                                    selectedColor === color
                                      ? "1px solid #333"
                                      : "1px solid #ccc",
                                  transition: "none",
                                  "&:hover": {
                                    backgroundColor: color,
                                  },
                                }}
                              />
                            </Tooltip>
                          ))}
                        </Stack>
                        {!offerImage && (
                          <TextField
                            type="file"
                            name="campImage"
                            disabled={isProcessing}
                            inputProps={{ accept: "image/*" }}
                            onChange={(e) => UploadBannerImage(e)}
                          />
                        )}
                        {offerImage && offerImageName && (
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={2}
                          >
                            <Typography
                              level="h2"
                              component="h2"
                              fontWeight="600"
                              fontSize="2rem"
                              alignSelf="center"
                            >
                              {offerImageName}
                            </Typography>
                            <Button
                              className="btn btn-primary align-self-start"
                              variant="contained"
                              onClick={handleCloseOfferImage}
                              disabled={isReadOnlyCampaign}
                            >
                              Delete Image
                            </Button>
                          </Stack>
                        )}
                      </FormControl>
                    )}

                    {campContentTypeValue === CampaignContentType.BannerImage &&
                      !offerImage && (
                        <FormControl className="font-size-14 m-0">
                          <TextField
                            type="file"
                            label="Image"
                            name="campImage"
                            disabled={isProcessing}
                            InputLabelProps={{
                              accept:
                                "image/png, image/jpeg, image/ico, image/jpg",
                              shrink: true,
                            }}
                            onChange={(e) => UploadBannerImage(e)}
                          />
                        </FormControl>
                      )}
                    {campContentTypeValue === CampaignContentType.BannerImage &&
                      offerImage && (
                        <Stack direction="row" alignItems="center" spacing={2}>
                          <Typography
                            level="h2"
                            component="h2"
                            fontWeight="600"
                            fontSize="1.5rem"
                            alignSelf="center"
                          >
                            {offerImageName}
                          </Typography>
                          <Button
                            className="btn btn-primary align-self-start"
                            variant="contained"
                            onClick={handleCloseOfferImage}
                          >
                            Delete Image
                          </Button>
                        </Stack>
                      )}

                    {campContentTypeValue ===
                      CampaignContentType.HtmlContent && (
                        <FormControl className="font-size-14 m-0">
                          <TextField
                            type="text"
                            multiline="true"
                            rows={5}
                            label="Html Code"
                            name="campHtml"
                            error={!creativeContent}
                            value={creativeContent}
                            onChange={(e) => setCreativeContent(e.target.value)}
                          />
                        </FormControl>
                      )}
                  </Stack>}
            </Box>
            <Box mt={4}>
              <Stack direction="row" spacing={2} justifyContent="stretch">
                <Typography
                  level="h3"
                  component="h3"
                  fontSize="1.8rem"
                  fontWeight="600"
                >
                  Use Custom Message
                </Typography>
                <Box className="toggle-switch" alignSelf="Center">
                  <input
                    checked={isCustomMsg}
                    onChange={handleCustomToggle}
                    type="checkbox"
                    id="customMessage"
                    disabled={isReadOnlyCampaign}
                  />
                  <label for="customMessage">Toggle</label>
                </Box>
              </Stack>
              <Stack spacing={2} mt={2}>
                <FormControl fullWidth>
                  <TextField
                    inputProps={{ style: { fontSize: 13 } }}
                    label=""
                    type="text"
                    value={creativeLine1}
                    onChange={(e) => {
                      if (!isReadOnlyCampaign) {
                        const text = e.target.value;
                        if (text.length <= 20 && !isLoading) {
                          setCreativeLine1(text)
                        }
                      }
                    }}
                    disabled={!isCustomMsg}
                    placeholder=""
                    maxLength={20}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    inputProps={{ style: { fontSize: 13 } }}
                    label=""
                    type="text"
                    value={creativeLine2}
                    onChange={(e) => {
                      if (!isReadOnlyCampaign) {
                        const text = e.target.value;
                        if (text.length <= 20 && !isLoading) {
                          setCreativeLine2(text)
                        }
                      }
                    }}
                    disabled={!isCustomMsg}
                    placeholder=""
                    maxLength={20}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    inputProps={{ style: { fontSize: 13 } }}
                    label=""
                    type="text"
                    value={creativeLine3}
                    onChange={(e) => {
                      if (!isReadOnlyCampaign) {
                        const text = e.target.value;
                        if (text.length <= 20 && !isLoading) {
                          setCreativeLine3(text)
                        }
                      }
                    }}
                    disabled={!isCustomMsg}
                    placeholder=""
                    maxLength={20}
                  />
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    inputProps={{ style: { fontSize: 13 } }}
                    label=""
                    type="text"
                    value={creativeLine4}
                    onChange={(e) => {
                      if (!isReadOnlyCampaign) {
                        const text = e.target.value;
                        if (text.length <= 20 && !isLoading) {
                          setCreativeLine4(text)
                        }
                      }
                    }}
                    disabled={!isCustomMsg}
                    placeholder=""
                    maxLength={20}
                  />
                </FormControl>
              </Stack>
            </Box>

            <Accordion
              defaultExpanded
              sx={{
                boxShadow: "none",
                background: "transparent",
                margin: "2rem 0 0 0 !important",
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ fontSize: "2.5rem" }} />}
                aria-controls="panel1-content"
                id="panel1-header"
                sx={{ padding: "0px" }}
              >
                <Typography
                  level="h3"
                  component="h3"
                  fontSize="1.8rem"
                  fontWeight="600"
                >
                  Marketing Channels
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0px" }}>
                <Stack spacing={2}>
                  <Stack className="font-size-14" spacing={1} direction="row">
                    <FormControl>
                      <Card sx={{ boxShadow: "none", borderRadius: "10px" }}>
                        <Stack
                          spacing={2}
                          padding={2}
                          direction="row"
                          justifyContent="space-between"
                        >
                          <Stack direction="row" spacing={2}>
                            <Box
                              component="img"
                              alt="Email"
                              src={Email_Img}
                              alignSelf="Center"
                              sx={{
                                width: "46px",
                              }}
                            />
                            <Stack>
                              <Typography
                                level="h3"
                                component="h3"
                                fontWeight="700"
                              >
                                <span>Email</span>
                                <Box
                                  className="toggle-switch"
                                  alignSelf="Center"
                                  sx={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                  }}
                                >
                                  <input
                                    checked={channels.includes(
                                      channelEnumTypes.Email
                                    )}
                                    onChange={(e) =>
                                      handleChannelChange(
                                        e,
                                        channelEnumTypes.Email
                                      )
                                    }
                                    disabled={isReadOnlyCampaign}
                                    type="checkbox"
                                    id="emailSwitch"
                                  />
                                  <label for="emailSwitch">Toggle</label>
                                </Box>
                              </Typography>
                              <Typography
                                level="h3"
                                component="h3"
                                fontWeight="400"
                              >
                                Email this campaign to the target customers
                              </Typography>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Card>
                    </FormControl>
                    <FormControl>
                      <Card sx={{ boxShadow: "none", borderRadius: "10px" }}>
                        <Stack
                          spacing={2}
                          padding={2}
                          direction="row"
                          justifyContent="space-between"
                        >
                          <Stack direction="row" spacing={2}>
                            <Box
                              component="img"
                              alt="Push Notification"
                              src={PushNotification_Img}
                              alignSelf="Center"
                              sx={{
                                width: "46px",
                              }}
                            />
                            <Stack>
                              <Typography
                                level="h3"
                                component="h3"
                                fontWeight="700"
                              >
                                <span>Push Notification</span>
                                <Box
                                  className="toggle-switch"
                                  alignSelf="Center"
                                  sx={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                  }}
                                >
                                  <input
                                    checked={channels.includes(
                                      channelEnumTypes.Push
                                    )}
                                    onChange={(e) =>
                                      handleChannelChange(
                                        e,
                                        channelEnumTypes.Push
                                      )
                                    }
                                    disabled={isReadOnlyCampaign}
                                    type="checkbox"
                                    id="pushSwitch"
                                  />
                                  <label for="pushSwitch">Toggle</label>
                                </Box>
                              </Typography>
                              <Typography
                                level="h3"
                                component="h3"
                                fontWeight="400"
                              >
                                Send this campaign as push notification in Infopass
                              </Typography>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Card>
                    </FormControl>
                    <FormControl>
                      <Card sx={{ boxShadow: "none", borderRadius: "10px" }}>
                        <Stack
                          spacing={2}
                          padding={2}
                          direction="row"
                          justifyContent="space-between"
                        >
                          <Stack direction="row" spacing={2}>
                            <Box
                              component="img"
                              alt="SMS"
                              src={SMS_Img}
                              alignSelf="Center"
                              sx={{
                                width: "46px",
                              }}
                            />
                            <Stack>
                              <Typography
                                level="h3"
                                component="h3"
                                fontWeight="700"
                              >
                                <span>SMS</span>
                                <Box
                                  className="toggle-switch"
                                  alignSelf="Center"
                                  sx={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                  }}
                                >
                                  <input
                                    checked={isSmsInclude}
                                    onChange={(e) =>
                                      handleChannelChange(
                                        e,
                                        channelEnumTypes.SMS
                                      )
                                    }
                                    disabled={isReadOnlyCampaign}
                                    type="checkbox"
                                    id="smsSwitch"
                                  />
                                  <label for="smsSwitch">Toggle</label>
                                </Box>
                              </Typography>
                              <Typography
                                level="h3"
                                component="h3"
                                fontWeight="400"
                              >
                                SMS this campaign to the target customers
                              </Typography>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Card>
                    </FormControl>
                  </Stack>
                </Stack>
              </AccordionDetails>
            </Accordion>

            <Accordion
              defaultExpanded
              sx={{ boxShadow: "none", background: "transparent" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ fontSize: "2.5rem" }} />}
                aria-controls="panel2-content"
                id="panel2-header"
                sx={{ padding: "0px" }}
              >
                <Typography
                  level="h3"
                  component="h3"
                  fontSize="1.8rem"
                  fontWeight="600"
                >
                  Target Customers
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: "0px" }}>
                <Stack spacing={2}>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid xs="12" sm="6" md="6">
                      <FormControl className="font-size-14">
                        <Typography
                          level="h3"
                          component="h3"
                          fontSize="1.4rem"
                          fontWeight="600"
                        >
                          Tiers
                        </Typography>
                        <FormGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          name="radio-buttons-group"
                          className="mt-1"
                          sx={{
                            maxHeight: "180px",
                            overflow: "auto",
                            flexDirection: "row",
                            padding: "1px",
                          }}
                        >
                          {!Utils.IsNullOrEmpty(tiersList) &&
                            tiersList.map((tier, index) => (
                              <FormControlLabel
                                checked={tier?.isChecked}
                                disabled={isProcessing}
                                onChange={(e) => handleTierChange(e, index)}
                                value={`${index + 1}`}
                                control={<Checkbox />}
                                label={`${tier.name} (${tier.locationTierCount || tier.customerCount
                                  })`}
                              />
                            ))}
                        </FormGroup>
                      </FormControl>
                    </Grid>
                    <Grid xs="12" sm="6" md="6" sx={{ paddingRight: "5%" }}>
                      <FormControl className="font-size-14 w-100">
                        <Stack direction="row" justifyContent="space-between" spacing={6} alignItems="center">
                        <Typography
                          level="h3"
                          component="h3"
                          fontSize="1.4rem"
                          fontWeight="600"
                        >
                          Locations
                        </Typography>
                        <Paper
                          component="form"
                          sx={{
                            p: "2px",
                            display: "flex",
                            alignItems: "center",
                            width: "300px",
                            marginBottom: 2,
                          }}
                          className="font-size-16"
                        >
                          <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Search Items"
                            value={searchLocationValue}
                            onChange={(e) => handleSearchLocation(e.target.value)}
                          />
                          {searchLocationValue && (
                              <IconButton
                                sx={{ p: "10px" }}
                                aria-label="clear"
                                onClick={() => handleSearchLocation("")}
                              >
                                <ClearIcon />
                              </IconButton>
                                      )}
                          <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
                            <SearchIcon />
                          </IconButton>
                        </Paper>
                        </Stack>
                        <FormGroup
                          className="mt-1"
                          // sx={{
                          //   height: "180px",
                          //   overflow: "auto",
                          //   flexDirection: "row",
                          //   padding: "1px",
                          // }}
                          sx={{
                            height: "180px",
                            overflow: "auto",
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            alignContent: "flex-start",   
                            gap: 0,
                            padding: "1px",
                          }}
                        >
                          {!Utils.IsNullOrEmptyArray(filteredLocationsList) &&
                            filteredLocationsList.map((location, index) => (
                              <FormControlLabel
                                checked={location.isChecked}
                                disabled={isProcessing}
                                onChange={(e) =>
                                  handleLocationChange(
                                    e,
                                    location?.tiers[0]?.customerCount || 0,
                                    location,
                                    index
                                  )
                                }
                                value={`${location.name}`}
                                control={<Checkbox />}
                                label={`${location.name} (${location?.tiers[0]?.customerCount})`}
                              />
                            ))}
                        </FormGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Stack>

                <Card
                  sx={{
                    boxShadow: "none",
                    borderRadius: "10px",
                    marginTop: "1rem",
                    background: "none"
                  }}
                >
                  <Stack
                    spacing={10}
                    padding={2}
                    direction="row"
                  >
                    <Typography
                      level="h3"
                      component="h3"
                      fontSize="1.6rem"
                      fontWeight="700"
                    >
                      Include Non-Loyalty Customers
                    </Typography>
                    <Box className="toggle-switch" alignSelf="Center">
                      <input
                        checked={anonymous}
                        onChange={handletoggleNonLoyality}
                        type="checkbox"
                        id="custSwitch"
                        disabled={isProcessing}
                      />
                      <label for="custSwitch">Toggle</label>
                    </Box>
                  </Stack>
                </Card>
              </AccordionDetails>
            </Accordion>

            <Stack direction="row" className="fixed-btn">
              <Grid className="container" justifyContent="end">
                <Stack direction="row" justifyContent="end" spacing={2}>
                  <FormControl>
                    <Button
                      type="submit"
                      variant="outlined"
                      className="btn btn-secondary"
                      disabled={isLoading}
                      onClick={onClickCancel}
                    >
                      Cancel
                    </Button>
                  </FormControl>
                  {!isReadOnlyCampaign && <FormControl>
                    <Button
                      type="submit"
                      variant="contained"
                      className="btn btn-primary"
                      disabled={isLoading}
                      onClick={handleSaveCampaign}
                    >
                      {campaignBtnStatus}
                    </Button>
                  </FormControl>}
                </Stack>
              </Grid>
            </Stack>
          </Grid>

          <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            className="cs-modal-sec"
            open={openSelectedProducts}
            PaperProps={{
              style: { width: '450px', maxWidth: '90%' },
            }}
          >
            <BootstrapDialogTitle
              id="customized-dialog-title"
              onClose={() => setOpenSelectedProducts(false)}
            >
              <Typography
                level="h3"
                component="h3"
                fontWeight="600"
                fontSize="2rem"
                className="h3"
              >
                Selected Products
              </Typography>
            </BootstrapDialogTitle>
            <DialogContent dividers className="modal-dialog-content" sx={{ backgroundColor: "#f4f4f4" }}>
              <Grid container sx={{ padding: "15px" }} className="card white-bg">

                <Stack className="font-size-16 w-100" spacing={1}>
                  {!Utils.IsNullOrEmptyArray(selectedProducts) && selectedProducts.map((selectedProduct) => (
                    <Card key={"category.class"} className="card p-1">
                      <Stack direction="row" spacing={2}>
                        <Box>
                          <Typography fontSize="1.6rem" fontWeight="600">
                            {selectedProduct.value || selectedProduct.Value}
                          </Typography>
                          <Typography fontSize="13px">
                            {selectedProduct.description || selectedProduct.Description}
                          </Typography>
                        </Box>
                      </Stack>
                    </Card>
                  ))}
                </Stack>
              </Grid>
            </DialogContent>
            <DialogActions style={{ padding: "15px", display: "flex", justifyContent: "flex-end" }}>
              <FormControl>
                <Button
                  type="submit"
                  variant="contained"
                  className="btn btn-secondary"
                  onClick={() => setOpenSelectedProducts(false)}
                >
                  Cancel
                </Button>
              </FormControl>
            </DialogActions>
          </BootstrapDialog>
        </Grid>
      </Grid>
    </Container>
  );
};

export default AddNewCampaign;
